export const urlApi = "https://techcaresolution-ssl.com/tcs-web-api/";
// export const urlApi = "http://localhost:5000";



// let url = 'https://147.50.158.20:9033'; /* Link จริง */
  // let url = "http://localhost:5000"; /* Link Test */

    // "homepage": "https://techcaresolution.co.th/",